<div
  *ngIf="element"
  class="surveys-element-input-phone-number"
  role="group"
>
  <surveys-element-question-text
    *ngIf="multipartQuestionHeader"
    [text]="multipartQuestionHeader"
    [textSize]="'small'"
    [classes]="['multipart-label']"
  ></surveys-element-question-text>
  <label for="element.id">
    <div class="label">
      <surveys-element-question-text
        [id]="element.id"
        [required]="element.required"
        [text]="element.label[language]"
      ></surveys-element-question-text>
    </div>

    <div class="inputs">
      <div class="input-element phone">
        <r-masked-input
          [control]="control"
          [shouldFocus]="shouldFocus"
          [placeholder]="'(555) 555-5555'"
          [type]="'tel'"
          [autocomplete]="'tel'"
          [labeledby]="element.id"
          [describedby]="
            multipartQuestionId ? multipartQuestionId : null
          "
          [mask]="inputMasks.phone"
          (keyUp)="keyMonitor($event)"
          (blur)="handleOnBlur()"
        >
        </r-masked-input>
      </div>
    </div>
  </label>
  <div class="button-element">
    <r-button
      *ngIf="showProceedActions()"
      class="continue-button"
      [e2e]="'button-' + element.id + '-continue'"
      [affirmative]="true"
      [negative]="false"
      [describedby]="element.id"
      (onClick)="advance()"
    >
      {{ 'surveys.navigation.continue' | translate }}
    </r-button>
  </div>
</div>
